import LearnAboutBillingPeriods from "./LearnAboutBillingPeriods/LearnAboutBillingPeriods";
import ProvisionDatePicker from "./ProvisionDatePicker/ProvisionDatePicker";
import SkuProvisionSummary from "./SkuProvisionSummary/SkuProvisionSummary";
import { ProvisionDisplayDetails } from "../types";

interface InProgressStepProps {
  details: ProvisionDisplayDetails;
  selectedDate: Date | null;
  onDateChange: (date: Date | null) => void;
}

const InProgressStep = ({
  details,
  selectedDate,
  onDateChange,
}: InProgressStepProps) => (
  <>
    <p className="sku-provision-intro">
      The following SKU will be marked as <strong>In progress</strong>.
    </p>
    <SkuProvisionSummary details={details} />
    <p className="sku-provision-guidance">
      Select a <strong>projected completion date</strong> to let users know
      when the product is expected to be available.{" "}
      <span>You can update the projected completion date later if needed.</span>
    </p>
    <ProvisionDatePicker
      selectedDate={selectedDate}
      onDateChange={onDateChange}
    />
    <LearnAboutBillingPeriods />
  </>
);

export default InProgressStep;
